import {
  type ButtonProps,
  Button as MuiButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const Button = styled(MuiButton)(({ theme }) => ({
  justifyContent: "flex-start",
  color: theme.palette.text.primary,
  padding: theme.spacing(0.5),
  ":hover": {
    backgroundColor: theme.palette.support[50],
  },
  ":disabled": {
    ".MuiTypography-root": {
      color: theme.palette.text.disabled,
    },
  },
  "& .MuiTouchRipple-child": {
    backgroundColor: theme.palette.support.dark,
  },
  "&:hover .MuiTouchRipple-child": {
    backgroundColor: theme.palette.support.dark,
  },
  "&.Mui-focusVisible .MuiTouchRipple-child": {
    backgroundColor: theme.palette.support.dark,
  },
}));

export function MenuButton({ children, ...props }: ButtonProps) {
  return (
    <Button {...props}>
      <Typography
        variant="body2"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {children}
      </Typography>
    </Button>
  );
}
